module.exports = __webpack_public_path__ + "static/media/preApprovedCar.cae3bb75.svg";